/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PatientCertificateDocument
 */
export interface PatientCertificateDocument {
    /**
     * 
     * @type {string}
     * @memberof PatientCertificateDocument
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCertificateDocument
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientCertificateDocument
     */
    'formType': PatientCertificateDocumentFormTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PatientCertificateDocument
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PatientCertificateDocument
     */
    'type': string;
}

/**
    * @export
    * @enum {string}
    */
export enum PatientCertificateDocumentFormTypeEnum {
    State = 'STATE',
    Clinic = 'CLINIC'
}


